import { initStore } from './store';
import InitialState from './initialState';

const configureStore = () => {
  const actions = {
    SET_LANGUAGE: (curState, language) => {
      if (curState.version) {
        if (curState.version.language.id !== language) {
          console.log(
            'SET_LANGUAGE: removing version',
            curState.version,
          );
          return {
            language,
            version: null,
          };
        } else {
          console.log(
            'SET_LANGUAGE: keeping version',
            curState.version,
          );
          return { language };
        }
      } else {
        console.log(
          'SET_LANGUAGE: removing version',
          curState.version,
        );
        return { language, version: null };
      }
    },
    SET_VERSION: (curState, version) => {
      return {
        language: version ? version.language.id : null,
        version: version ? version : null,
      };
    },
    SET_BOOK: (curState, book) => {
      return {
        book,
      };
    },
    SET_CHAPTER: (curState, chapter) => {
      return {
        chapter,
      };
    },
    SET_IS_SAVED: (curState, isSaved) => {
      return {
        isSaved,
      };
    },
    SET_SOURCE_VERSION_OPTIONS: (curState, sourceVersionOptions) => {
      return { sourceVersionOptions };
    },
    CLEAR_STATE: (curState) => {
      return {
        version: null,
        book: null,
        chapter: null,
        isSaved: false,
      };
    },
    SET_USER: (curState, authuser) => {
      return { authuser };
    },
  };

  initStore(actions, InitialState);
};

export default configureStore;
